import ForgotPasswordForm from './ForgotPasswordForm.js';

export default ForgotPasswordForm;
